import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import { asTitle } from "utils/Utils";

import { createTrajectoryReport } from "core/report/ReportService";

export type CreateReportDialogProps = {
	trajectoryId: number;
	reportBlueprints: string[];

	onClose: () => void;
};

export default function CreateReportDialog(
	props: Readonly<CreateReportDialogProps>
): JSX.Element {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	function createReport(name: string): void {
		createTrajectoryReport(props.trajectoryId, name).then(loc => {
			const id = parseInt(loc.substring(loc.lastIndexOf("/") + 1));
			navigate(`${location.pathname}/${id}?edit=true`);
		});
	}

	return (
		<Dialog
			open={true}
			onClick={e => e.stopPropagation()}
			onClose={props.onClose}>
			<DialogTitle>{asTitle(t("createReport"))}</DialogTitle>
			<DialogContent>
				<List>
					{props.reportBlueprints.map(name => (
						<ListItem disablePadding key={name}>
							<ListItemButton onClick={() => createReport(name)}>
								<ListItemText primary={name} />
							</ListItemButton>
						</ListItem>
					))}
				</List>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose}>{asTitle(t("cancel"))}</Button>
			</DialogActions>
		</Dialog>
	);
}
